import { v7 as uuidv7 } from "uuid";

/**
 * A new id made in the browser: a UUID version 7 (guide 4.7).
 *
 * For things that may be sent twice: a sale, a credit payment, a transfer, a
 * medicine added from Add sale. Make it ONCE, when the person starts that thing,
 * and send the same id again if they press twice or the network fails. The
 * server then answers with the first result instead of recording it again.
 * Never make a new id on a retry.
 */
export function newId(): string {
  return uuidv7();
}
